import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Register_img from "../../assests/Register_Work_7 1.png";
import style from "./Register.module.css";
import { RxEyeOpen, RxEyeClosed } from "react-icons/rx";
import {
  Alert,
  Snackbar,
} from "@mui/material";
import { baseurl } from "../Url";
import { IoCheckmarkCircle } from "react-icons/io5";
import { Country } from "country-state-city";


function Register() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agreed, setAgreed] = useState(false)
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [userName, setUserName] = useState("")
  const [email, setEmail] = useState("")
  const [grade, setGrade] = useState("")
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [validationErrors, setValidationErrors] = useState({});
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [doPasswordsMatch, setDoPasswordsMatch] = useState(false);
  const [doConfirmPasswordsMatch, setDoConfirmPasswordsMatch] = useState(null);
  const [signUpCountry, setSignUpCountry] = useState({
    name: "",
    isoCode: "",
  });
  const [apiError, setApiError] = useState("")
  const [recaptchaSiteKey, setRecaptchaSiteKey] = useState("")
  const [passwordCriteria, setPasswordCriteria] = useState({
    length: false,
    uppercase: false,
    number: false,
    specialChar: false,
  })

  useEffect(() => {
    let active = true;
    document.body.classList.add("recaptcha-active");
    fetch(`${baseurl}/account/signup/recaptcha-config`)
      .then((response) => {
        if (!response.ok) throw new Error("Unable to load signup security check.");
        return response.json();
      })
      .then(({ site_key: siteKey }) => {
        if (!active || !siteKey) return;
        setRecaptchaSiteKey(siteKey);
        const existingScript = document.querySelector('script[data-recaptcha-v3="true"]');
        if (existingScript) return;
        const script = document.createElement("script");
        script.dataset.recaptchaV3 = "true";
        script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      })
      .catch(() => {
        if (active) setApiError("Signup security check is unavailable. Please try again later.");
      });
    return () => {
      active = false;
      document.body.classList.remove("recaptcha-active");
    };
  }, []);

  const handleCountryChange = (e) => {
    const selectedCountry = Country.getAllCountries().find(
      (country) => country.isoCode === e.target.value
    );
    if (selectedCountry) {
      setSignUpCountry({
        name: selectedCountry.name,
        isoCode: selectedCountry.isoCode,
      });
      setValidationErrors((prevErrors) => ({ ...prevErrors, country: '' }));

    }
  };


  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const handleCheckboxChange = (event) => {
    setAgreed(event.target.checked);
  };
  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      password: "",
    }));
    const criteria={
      length: newPassword.length >= 8,
      uppercase: /[A-Z]/.test(newPassword),
      number: /\d/.test(newPassword),
      specialChar: /[-!@#$%^&*]/.test(newPassword),
    };
      setPasswordCriteria(criteria);

    setDoPasswordsMatch(validatePassword(newPassword));
    if (confirmPassword === "") {
      setDoConfirmPasswordsMatch(null);
    } else {
      setDoConfirmPasswordsMatch(confirmPassword === newPassword);
    }
  };



  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setConfirmPassword(newConfirmPassword);
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      confirmPassword: "",
    }));
    setDoConfirmPasswordsMatch(
      newConfirmPassword === "" ? null : newConfirmPassword === password
    );
  };


  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = re.test(email);
    setIsEmailValid(isValid);
    return isValid;
  };

  const validatePassword = (password) => {
    const re = /^(?=.*[0-9])(?=.*[-!@#$%^&*])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;
    return re.test(password) && !/\s/.test(password);
  };


  const validateForm = () => {
    const errors = {};

    if (!firstName) errors.firstName = true;
    if (!lastName) errors.lastName = true;
    if (!userName) errors.userName = true;
    if (!signUpCountry.name) errors.country = true;
    if (!email) {
      errors.email = true;
    } else if (!validateEmail(email)) {
      errors.email = true;
    }
    if (!grade) errors.grade = true;
    if (!password) {
      errors.password = true;
    } else if (!validatePassword(password)) {
      errors.password = true;
    }
    if (!confirmPassword) {
      errors.confirmPassword = true;
    } else if (password !== confirmPassword) {
      errors.confirmPassword = true;
    }
    if (!agreed) errors.agreed = true;

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setApiError("");
      try {
        if (!recaptchaSiteKey || !window.grecaptcha) {
          throw new Error("Signup security check is still loading. Please try again.");
        }
        const token = await new Promise((resolve, reject) => {
          window.grecaptcha.ready(() => {
            window.grecaptcha.execute(recaptchaSiteKey, { action: "signup" })
              .then(resolve)
              .catch(reject);
          });
        });
        if (!token) {
          throw new Error("Signup security check did not return a token. Please refresh and try again.");
        }
        await userSignUp(token);
      } catch (error) {
        setApiError(error.message || "Signup security check failed. Please try again.");
      }
    }
  };

  async function userSignUp(recaptchaToken) {
    const body = {
      FirstName: firstName,
      LastName: lastName,
      Username: userName,
      Password: password,
      Email: email,
      grade: grade,
      country: signUpCountry.name,
      recaptchaToken,
    };

    const response = await fetch(`${baseurl}/account/signup/v1`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
        console.log(data);
        if (data.status === "success") {
          navigate("/email/verification", {
            state: {
              Email: email
            }
          })

        } else if (data.status === "error" || data.status === "failed") {
          if (data.message === "Email address already exists. Please choose a different one.") {
            setApiError("Email address already exists. Please choose a different one.");
          }
          else if (data.message === "Username already exists. Please choose a different one.") {
            setApiError("Username already exists. Please choose a different one.")
          }
          else setApiError(data.message || "Unable to create your account. Please try again.");

        }
  }


  return (
    <div className={style.Container}>
      <div className={style.RegisterBody}>
        <div className={style.registerBodyLeft}>
          <div className={style.formBox}>
            <div className={style.welcomeTxt}>
              <p className={style.welcomeHead}>
                {" "}
                Welcome to <span>English Wagon</span>{" "}
              </p>
              <p className={style.welcomeSubHead}>
                Here’s where you start your journey to real world
                English!
              </p>
            </div>

            <div className={style.formContainer}>
              <div className={style.formFeilds}>
                <div className={style.formGroup}>
                  <div className={`${style.names} ${validationErrors.firstName ? style.error : ''}`}>
                    <input
                      type="text"
                      placeholder="First Name"
                      name="firstName"
                      required
                      value={firstName}
                      onChange={(e) => {
                        setFirstName(e.target.value)
                        setValidationErrors((prevErrors) => ({ ...prevErrors, firstName: '' }));
                      }}
                    />
                  </div>
                  <div className={`${style.names} ${validationErrors.lastName ? style.error : ''}`}>
                    <input
                      type="text"
                      placeholder="Last Name"
                      name="lastName"
                      required
                      value={lastName}
                      onChange={(e) => {
                        setLastName(e.target.value)
                        setValidationErrors((prevErrors) => ({ ...prevErrors, lastName: '' }));
                      }}
                    />
                  </div>
                </div>

                <div className={style.formGroup}>
                  <div className={`${style.Username} ${validationErrors.userName ? style.error : ''}`} >
                    <input
                      type="text"
                      placeholder="Username"
                      name="username"
                      required
                      value={userName}
                      onChange={(e) => {
                        setUserName(e.target.value)
                        setValidationErrors((prevErrors) => ({ ...prevErrors, userName: '' }));
                      }}
                    />
                  </div>
                  <div className={`${style.selectContainer} ${validationErrors.country ? style.error : ''}`} >
                    <select
                      name="Country"
                      required
                      value={signUpCountry.isoCode}
                      onChange={handleCountryChange}
                    >
                      <option disabled value="">Country</option>
                      {Country.getAllCountries().map((list) => {
                        return (
                          <option key={list.isoCode} value={list.isoCode}>
                            {list.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className={style.formGroup}>
                  <div className={`${style.emailBox} ${validationErrors.email ? style.error : ''}`} >

                    <input
                      type="text"
                      placeholder="E-mail"
                      name="email"
                      required
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value)
                        setValidationErrors((prevErrors) => ({ ...prevErrors, email: '' }));
                        setApiError("")
                      }}
                    />
                    {isEmailValid && (
                      <span className={style.checkMark}>
                        <IoCheckmarkCircle />
                      </span>
                    )}
                  </div>
                  <div className={`${style.selectContainer} ${validationErrors.grade ? style.error : ''}`}>
                    <select
                      name="grade"
                      required
                      value={grade}
                      onChange={(e) => {
                        setGrade(e.target.value)
                        setValidationErrors((prevErrors) => ({ ...prevErrors, grade: '' }));
                      }}
                    >
                      <option disabled value="">Grade</option>
                      {Array.from({ length: 8 }, (_, i) => i + 5).map((gradeNum) => {
                        return (
                          <option key={gradeNum} value={gradeNum}>
                            Grade {gradeNum}
                          </option>
                        );
                      })}
                      <option value="13">Grade 12+</option>
                    </select>
                  </div>
                </div>
                {validationErrors.email && (
                  <p style={{ color: "red", padding: ".25rem 0 0" }}>
                    {!email.trim()
                      ? "Please enter your email address."
                      : "Please enter a valid email address."}
                  </p>
                )}

                <div className={style.formGroup}>
                  <div className={`${style.passwordForm} ${validationErrors.password ? style.error : ''}`} >
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      name="psw"
                      required
                      value={password}
                      onChange={handlePasswordChange}
                    />
                    {showPassword ? (
                      <RxEyeOpen
                        className={style.eyeIco}
                        onClick={togglePasswordVisibility}
                      />
                    ) : (
                      <RxEyeClosed
                        className={style.eyeIco}
                        onClick={togglePasswordVisibility}
                      />
                    )}
                    {/* <span onClick={togglePasswordVisibility} className={style.eyeIco}>
                      {showPassword ? <RxEyeOpen /> : <RxEyeClosed />}
                    </span> */}
                    {doPasswordsMatch && (
                      <span className={style.checkMark}>
                        <IoCheckmarkCircle />
                      </span>
                    )}
                  </div>
                  <div className={`${style.passwordForm} ${validationErrors.confirmPassword ? style.error : ''}`} >
                    <input
                      style={{ width: "95%" }}
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Confirm password"
                      name="psw"
                      required
                      value={confirmPassword}
                      onChange={handleConfirmPasswordChange}
                    />
                    {showConfirmPassword ? (
                      <RxEyeOpen
                        className={style.eyeIco}
                        onClick={toggleConfirmPasswordVisibility}
                      />
                    ) : (
                      <RxEyeClosed
                        className={style.eyeIco}
                        onClick={toggleConfirmPasswordVisibility}
                      />
                    )}
                    {doConfirmPasswordsMatch && (
                      <span className={style.checkMark}>
                        <IoCheckmarkCircle />
                      </span>
                    )}
                  </div>
                </div>
              </div>
              {doConfirmPasswordsMatch === false && confirmPassword !== "" && (
                <p style={{ color: "red", padding: ".5rem 0" }}>Passwords do not match</p>
              )}
              {validationErrors.password && password.length > 0 ? (
                <div className={style.passwordCondition}>
                  <div className={style.specialCharacter}>*</div>
                  <div className={style.passwordConditionText}>
                    <p>
                      <span style={{color: passwordCriteria.length ? "rgb(15, 175, 167)" : "grey"}}> At least 8 characters </span>,{" "}
                      <span style={{color: passwordCriteria.uppercase ? "rgb(15, 175, 167)" : "grey"}}>  1 uppercase letter </span>,{" "}
                      <span style={{color: passwordCriteria.number ? "rgb(15, 175, 167)" : "grey"}}> 1 number </span> and{" "}
                      <span style={{color: passwordCriteria.specialChar ? "rgb(15, 175, 167)" : "grey"}}> 1 special character </span>.
                    </p>
                  </div>
                </div>
              ) : null}
              {apiError && (<p style={{ color: "red", padding: ".5rem 0" }}>{apiError}</p>)}

              <div className={style.declare}>
                <label className={style.customCheckbox}>
                  <input
                    type="checkbox"
                    name="remember"
                    checked={agreed}
                    onChange={handleCheckboxChange}
                  />
                  <span className={style.checkmark}></span>
                  &nbsp;
                  <p>
                    I am aged 18 or over and agree to the{" "}
                    <a href="https://englishwagon.com/terms-conditions/" target="_blank" rel="noopener noreferrer">Terms and conditions</a> and{" "}
                    <a href="https://englishwagon.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy policy</a>{" "}
                  </p>
                </label>
              </div>

              <button style={{ backgroundColor: !agreed ? "#898890" : "", opacity: !agreed ? "0.75" : "" }} disabled={!agreed} onClick={(e) => handleSubmit(e)}>Sign Up</button>

              <div className={style.signUp}>
                <p>Already have an account?</p>
                <p>
                  <span onClick={() => {
                    navigate("/login")
                  }}>Login</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className={style.registerBodyRight}>
          <div className={style.groupImg}>
            <img src={Register_img} alt="English Wagon register" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
